import React from "react"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

import Link from "../../../components/Link"
import Seo from "../../../components/seo"
import Vimeo from "../../../components/vimeo"

const Jul2023Page = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  // override:
  customCrumbLabel = "jul"
  let seoImage = {
    src: "//ementodk.netlify.app/images/previews/internal_preview.jpg",
    width: 1024,
    height: 566,
  }
  return (
    <Layout location={props.location}>
      <Seo
        title="Emento Koppen"
        image={seoImage}
        pathname="team/internal/jul"
      />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner default-size">
            <div className="space-8" />
            <div className="two-col gap">
              <div className="box">
                <h1>Emento Koppen</h1>
                <p>
                  Mange aspekter spiller ind i skabelsen af den perfekte
                  kaffestund.
                </p>
                <p>
                  Hos Emento har vi bedt Marie fra Solltau Studio om at dreje en
                  Emento kop. Den skal ligge godt i hånden, have den rette vægt
                  og rumfang, være nem at rengøre, føles lækker at røre ved og
                  selvfølgelig være en fryd for øjet.
                </p>
                <p>
                  Heldigvis sagde Marie straks ja til at hjælpe os med denne
                  opgave.
                </p>
                <p>
                  Marie er selvstændig og selvlært keramiker - oprindeligt en
                  “statskundskaber” fra Aarhus, men droppede udsigterne til at
                  arbejde med politik for at forfølge hendes stærke interesse
                  for håndværk, nærmere brugskunst og -genstande i lertøj.
                  Hendes værksted ligger midt i naturen, uden for Bogense på
                  Nordfyn.
                </p>
                <p>
                  Processen for at lave Emento Koppen har taget ugevis og krævet
                  tålmodighed, når en klump ler skal forvandles til mange
                  kopper. Marie har drejet og trimmet alle kopperne i hånden på
                  sin drejeskive - én efter én. Derefter ladet dem tørre
                  grundigt. Så brændt dem første gang. Så glaseret dem med
                  Emento's nye blå farve og endeligt, brændt dem igen.
                </p>
              </div>
              <div className="box">
                <img
                  src="/images/team/jul/solltau01.jpg"
                  alt="Solltau Studio Emento kop"
                />
              </div>
            </div>
            <p>
              Vi var heldige at blive inviteret indenfor undervejs og fik en
              hilsen med fra Marie:
            </p>
            <div className="video-player">
              <Vimeo
                videoSrcURL="https://player.vimeo.com/video/895251818?h=4a8e8665ad&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                videoTitle="Solltau Studio / Emento"
                iframeStyle="video-iframe"
              />
            </div>
            <p className="credits">
              Musik: Mikkel Bech. Indspillet med Emento Preamp #0001
            </p>
            <div className="space-4" />
            <p>
              Det er ikke tilfældigt, at vi vælger Marie som medskaber af Emento
              julegaven 2023. En passioneret, dansk solokunstner som hende, ser
              vi en mening i at støtte - ligesom temaet for årets julegave “Den
              perfekte kaffestund” indebærer økologiske, danske godter taget til
              et suprême niveau, kaffebønner valgt ud i fællesskab med fokus på
              det sanselige og ansvarlige aspekt samt en bæredygtig flaske til
              postevand, der rimer på{" "}
              <Link to="https://brand.emento.dk/core-values/">
                vores værdier
              </Link>{" "}
              - imagination, ordentlighed, giv-giv-giv og venskab.
            </p>

            <p>Glædelig jul, alle sammen!</p>
            <p>
              Læs mere om Solltau Studio her:{" "}
              <Link to="https://solltaustudio.com/">www.solltaustudio.com</Link>{" "}
              og på hendes Instagram{" "}
              <Link to="https://www.instagram.com/solltaustudio/">
                @solltaustudio
              </Link>
            </p>
            <p className="instagram-row">
              <img src="/images/team/jul/solltau04.jpg" alt="Solltau Studio" />
              <img src="/images/team/jul/solltau02.jpg" alt="Solltau Studio" />
              <img src="/images/team/jul/solltau05.jpg" alt="Solltau Studio" />
              <img src="/images/team/jul/solltau03.jpg" alt="Solltau Studio" />
            </p>
            <div className="space-8" />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Jul2023Page
